/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./new-loading.vue?vue&type=template&id=225c7fd3&scoped=true&"
import script from "./new-loading.vue?vue&type=script&lang=js&"
export * from "./new-loading.vue?vue&type=script&lang=js&"
import style0 from "./new-loading.vue?vue&type=style&index=0&id=225c7fd3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c7fd3",
  null
  
)

export default component.exports